"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeDisplayData = exports.NodeDisplayData = void 0;
/**
 * Sigma.js Display Data Classes
 * ==============================
 *
 * Classes representing nodes & edges display data aiming at facilitating
 * the engine's memory representation and keep them in a pool to avoid
 * requiring to allocate memory too often.
 *
 * NOTE: it's possible to optimize this further by maintaining display data
 * in byte arrays but this would prove more tedious for the rendering logic
 * afterwards.
 */
var NodeDisplayData = /** @class */ (function () {
    function NodeDisplayData(index, settings) {
        this.index = index;
        this.x = 0;
        this.y = 0;
        this.size = 2;
        this.color = settings.defaultNodeColor;
        this.hidden = false;
        this.label = "";
    }
    NodeDisplayData.prototype.assign = function (data) {
        for (var key in data)
            this[key] = data[key];
    };
    return NodeDisplayData;
}());
exports.NodeDisplayData = NodeDisplayData;
var EdgeDisplayData = /** @class */ (function () {
    function EdgeDisplayData(index, settings) {
        this.index = index;
        this.size = 1;
        this.color = settings.defaultEdgeColor;
        this.hidden = false;
        this.label = "";
    }
    EdgeDisplayData.prototype.assign = function (data) {
        for (var key in data)
            this[key] = data[key];
    };
    return EdgeDisplayData;
}());
exports.EdgeDisplayData = EdgeDisplayData;
